import { render, staticRenderFns } from "./AgencyComparison.vue?vue&type=template&id=13293a84&"
import script from "./AgencyComparison.vue?vue&type=script&lang=js&"
export * from "./AgencyComparison.vue?vue&type=script&lang=js&"
import style0 from "./AgencyComparison.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports